import CraftItem from "../JSON/CraftItem.json";
import ItemName from "../JSON/ItemName.json";

const hash = { ...CraftItem, ...ItemName };

export default id => hash[id].name;
